<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('manage.payments-report.index')">Customer Payments</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      ID {{ item.id }}
    </h1>

    <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
      <div>
        <h3>Payment Details</h3>

        <table class="table bg-white mt-2 w-full">
          <tr class="border-t border-gray-300">
            <th class="px-6 pt-6 pb-4 bg-gray-200 text-left">Payment ID</th>
            <td class="px-6 pt-6 pb-4 text-left">{{ item.id }}</td>
          </tr>
          <tr class="border-t border-gray-300">
            <th class="px-6 pt-6 pb-4 bg-gray-200 text-left">Customer</th>
            <td class="px-6 pt-6 pb-4 text-left">
             <span v-if="item.customer_code">
               {{  item.customer.name}} <span class="text-sm text-gray-400">| {{ item.customer_code }}</span>
             </span>
            </td>
          </tr>
          <tr class="border-t border-gray-300">
            <th class="px-6 pt-6 pb-4 bg-gray-200 text-left">Source</th>
            <td class="px-6 pt-6 pb-4 text-left">{{ item.source }}</td>
          </tr>
          <tr class="border-t border-gray-300">
            <th class="px-6 pt-6 pb-4 bg-gray-200 text-left">Bank Account</th>
            <td class="px-6 pt-6 pb-4 text-left">{{ item.account }}</td>
          </tr>
          <tr class="border-t border-gray-300">
            <th class="px-6 pt-6 pb-4 bg-gray-200 text-left">Description</th>
            <td class="px-6 pt-6 pb-4 text-left text-sm">{{ item.description }}</td>
          </tr>
          <tr class="border-t border-gray-300">
            <th class="px-6 pt-6 pb-4 bg-gray-200 text-left">Amount</th>
            <td class="px-6 pt-6 pb-4 text-left">{{ item.currency }} {{ item.amount.toLocaleString() }}</td>
          </tr>
        </table>
      </div>
      <div>
        <div v-if="item.customer_code">
          <h3>Attached Order</h3>
        </div>
        <div v-else>
          <h3>Select a matching order</h3>
          <div class="space-y-4 mt-2">
            <div v-for="match in matching_orders">
              <!--
                Checked: "border-transparent", Not Checked: "border-gray-300"
                Active: "border-indigo-500 ring-2 ring-indigo-500"
              -->
              <label :class="match.id === matchForm.order_id ? 'border-transparent' : 'border-gray-300'" class="relative block bg-white border rounded-lg shadow-sm px-6 py-2 cursor-pointer sm:flex sm:justify-between focus:outline-none">
                <input type="radio" :value="match.id"  v-model="matchForm.order_id">
                <div class="flex items-center mb-1 flex-grow pl-3">
                  <div class="text-sm">
                    <p class="font-medium text-gray-700">Order #{{ match.id }}</p>
                    <p class="font-large text-gray-900">{{ match.customer_account.name }}</p>
                    <div id="server-size-0-description-0" class="text-gray-500">
                      <p class="sm:inline">Created by {{ match.created_by.first_name }} {{ match.created_by.last_name }}</p>
                      <span class="hidden sm:inline sm:mx-1" aria-hidden="true">&middot;</span>
                      <p class="sm:inline"><span class="text-xs">📞</span> {{ match.created_by.mobile }}</p>
                    </div>
                  </div>
                </div>
                <div class="mt-2 flex text-sm sm:mt-0 sm:block sm:ml-4 sm:text-right">
                  <div class="font-medium text-gray-900">{{ match.status.toUpperCase() }}</div>
                  <div class="ml-1 text-gray-500 sm:ml-0">{{ match.created_at | localDateTime }}</div>
                </div>
                <!--
                  Active: "border", Not Active: "border-2"
                  Checked: "border-indigo-500", Not Checked: "border-transparent"
                -->
                <div :class="match.id === matchForm.order_id ? 'border border-primary-500' : 'border-transparent' " class="absolute -inset-px rounded-lg border-2 pointer-events-none" aria-hidden="true"></div>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import Layout from '@/Shared/Admin/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '@/Shared/SelectInput'
import TextInput from '@/Shared/TextInput'

export default {
  name: 'Show',
  layout: Layout,
  components: {
    LoadingButton,
    SelectInput,
    TextInput
  },

  props: {
    item: {
      type: Object,
      required: true
    },
    orders: {
      type: Array,
    },
    matching_orders: Array
  },

  data() {
    return {
      matchForm : {
        order_id: null
      }
    }
  }
}
</script>

